 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLEBB from '@/components/xhtml/EBB'
 import XHTMLTLU from '@/components/xhtml/TLU'
 import XHTMLPORT from '@/components/xhtml/port'
 import XHTMLMM from '@/components/xhtml/MM'
 import XHTMLALST from '@/components/xhtml/ALST'
 import XHTMLLOVE1 from '@/components/xhtml/love1'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLPROLOGUE from '@/components/xhtml/Prologue'
 import XHTMLCHAPTER01 from '@/components/xhtml/Chapter01'
 import XHTMLCHAPTER02 from '@/components/xhtml/Chapter02'
 import XHTMLCHAPTER03 from '@/components/xhtml/Chapter03'
 import XHTMLCHAPTER04 from '@/components/xhtml/Chapter04'
 import XHTMLCHAPTER05 from '@/components/xhtml/Chapter05'
 import XHTMLCHAPTER06 from '@/components/xhtml/Chapter06'
 import XHTMLCHAPTER07 from '@/components/xhtml/Chapter07'
 import XHTMLCHAPTER08 from '@/components/xhtml/Chapter08'
 import XHTMLCHAPTER09 from '@/components/xhtml/Chapter09'
 import XHTMLCHAPTER10 from '@/components/xhtml/Chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/Chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/Chapter12'
 import XHTMLCHAPTER13 from '@/components/xhtml/Chapter13'
 import XHTMLCHAPTER14 from '@/components/xhtml/Chapter14'
 import XHTMLCHAPTER15 from '@/components/xhtml/Chapter15'
 import XHTMLCHAPTER16 from '@/components/xhtml/Chapter16'
 import XHTMLCHAPTER17 from '@/components/xhtml/Chapter17'
 import XHTMLLOVE2 from '@/components/xhtml/love2'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLBACKEDBACKAD_1 from '@/components/xhtml/Backed/backad_1'
 import XHTMLORIMAD from '@/components/xhtml/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Cover",
 			"name" : "xhtml/Cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/EBB",
 			"name" : "xhtml/EBB",
 			"component" : XHTMLEBB
 		},
 		{
 			"path" : "/xhtml/TLU",
 			"name" : "xhtml/TLU",
 			"component" : XHTMLTLU
 		},
 		{
 			"path" : "/xhtml/port",
 			"name" : "xhtml/port",
 			"component" : XHTMLPORT
 		},
 		{
 			"path" : "/xhtml/MM",
 			"name" : "xhtml/MM",
 			"component" : XHTMLMM
 		},
 		{
 			"path" : "/xhtml/ALST",
 			"name" : "xhtml/ALST",
 			"component" : XHTMLALST
 		},
 		{
 			"path" : "/xhtml/love1",
 			"name" : "xhtml/love1",
 			"component" : XHTMLLOVE1
 		},
 		{
 			"path" : "/xhtml/Title",
 			"name" : "xhtml/Title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/Dedication",
 			"name" : "xhtml/Dedication",
 			"component" : XHTMLDEDICATION
 		},
 		{
 			"path" : "/xhtml/Prologue",
 			"name" : "xhtml/Prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/Chapter01",
 			"name" : "xhtml/Chapter01",
 			"component" : XHTMLCHAPTER01
 		},
 		{
 			"path" : "/xhtml/Chapter02",
 			"name" : "xhtml/Chapter02",
 			"component" : XHTMLCHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js